import React, { useState, useEffect } from 'react';
import api from '../api';
import Layout from '../components/Layout';
import HotspotEditor from '../components/HotspotEditor';

const UPLOADS_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:3301/api').replace('/api', '');

// MOTOR_TYPES sekarang diambil dinamis dari /api/motor-types (bisa di-CRUD admin)

// Placeholder gear person — ganti ke UPLOADS_BASE/uploads/gear-person.png begitu asset asli siap
const GEAR_PLACEHOLDER = "data:image/svg+xml;utf8," + encodeURIComponent(`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 400">
    <circle cx="100" cy="50" r="35" fill="#262b33"/>
    <rect x="70" y="90" width="60" height="120" rx="16" fill="#262b33"/>
    <rect x="55" y="100" width="20" height="90" rx="10" fill="#262b33"/>
    <rect x="125" y="100" width="20" height="90" rx="10" fill="#262b33"/>
    <rect x="75" y="210" width="22" height="150" rx="10" fill="#262b33"/>
    <rect x="103" y="210" width="22" height="150" rx="10" fill="#262b33"/>
  </svg>
`);

const GEAR_SUGGESTED_LABELS = ['Helm', 'Intercom', 'Jaket', 'Sarung Tangan', 'Sepatu', 'Tas'];
const MOTOR_SUGGESTED_LABELS = ['Ban', 'Lampu', 'Shock Breaker', 'Knalpot', 'Jok', 'Mesin'];

const SOCIAL_PLATFORMS = [
  { key: 'instagram', label: 'Instagram', icon: 'fa-brands fa-instagram', color: '#E4405F', placeholder: 'https://instagram.com/username' },
  { key: 'tiktok', label: 'TikTok', icon: 'fa-brands fa-tiktok', color: '#F0EDE4', placeholder: 'https://tiktok.com/@username' },
  { key: 'youtube', label: 'YouTube', icon: 'fa-brands fa-youtube', color: '#FF0000', placeholder: 'https://youtube.com/@channel' },
  { key: 'facebook', label: 'Facebook', icon: 'fa-brands fa-facebook', color: '#1877F2', placeholder: 'https://facebook.com/username' },
  { key: 'whatsapp', label: 'WhatsApp', icon: 'fa-brands fa-whatsapp', color: '#25D366', placeholder: 'https://wa.me/62812xxxxxxx' },
];

export default function Profile() {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ name: '', phone: '', email: '', quote: '', urgent_contact_name: '', urgent_contact_phone: '', urgent_contact_relation: '' });
  const [photoUrl, setPhotoUrl] = useState('');
  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const [motorType, setMotorType] = useState('');
  const [motorTypes, setMotorTypes] = useState([]);
  const [motorSpecs, setMotorSpecs] = useState([]);
  const [gearSpecs, setGearSpecs] = useState([]);
  const [socialLinks, setSocialLinks] = useState({});

  useEffect(() => {
    api.get('/member-auth/me').then((res) => {
      const m = res.data;
      setMember(m);
      setForm({
        name: m.name || '',
        phone: m.phone || '',
        email: m.email || '',
        quote: m.quote || '',
        urgent_contact_name: m.urgent_contact_name || '',
        urgent_contact_phone: m.urgent_contact_phone || '',
        urgent_contact_relation: m.urgent_contact_relation || '',
      });
      setPhotoUrl(m.photo_url || '');
      setMotorType(m.motor_type_id || '');
      // Backward-compat: kalau masih format object lama (fixed-key), reset ke array kosong biar gak error
      setMotorSpecs(Array.isArray(m.motor_specs) ? m.motor_specs : []);
      setGearSpecs(Array.isArray(m.gear_specs) ? m.gear_specs : []);
      setSocialLinks(m.social_links || {});
    }).catch((err) => console.error(err)).finally(() => setLoading(false));

    api.get('/motor-types').then((res) => setMotorTypes(res.data)).catch((err) => console.error(err));
  }, []);

  const handlePhotoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploadingPhoto(true);
    try {
      const fd = new FormData();
      fd.append('photo', file);
      const res = await api.post('/upload/photo', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setPhotoUrl(res.data.url);
    } catch (err) {
      alert('Gagal upload foto');
    } finally {
      setUploadingPhoto(false);
    }
  };

  const handleSaveProfile = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put('/member-auth/me', { ...form, photo_url: photoUrl });
      alert('Profil berhasil disimpan');
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menyimpan profil');
    } finally {
      setSaving(false);
    }
  };

  const handleMotorTypeChange = async (newTypeId) => {
    setMotorType(newTypeId);
    try {
      await api.put('/member-auth/me/motor-type', { motor_type_id: newTypeId });
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal update tipe motor');
    }
  };

  const handleSaveSocialLinks = async () => {
    setSaving(true);
    try {
      await api.put('/member-auth/me/social-links', { social_links: socialLinks });
      alert('Link sosial media berhasil disimpan');
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menyimpan link sosial media');
    } finally {
      setSaving(false);
    }
  };

  const inputStyle = { background: '#12151A', border: '1px solid #262b33', borderRadius: 6, padding: '10px 12px', color: '#F0EDE4', fontSize: 14, width: '100%' };

  if (loading) return <Layout><p style={{ color: '#8B92A0' }}>Memuat...</p></Layout>;

  const selectedMotor = motorTypes.find(t => t.id === motorType);

  return (
    <Layout>
      <h1 style={{ fontSize: 26, fontWeight: 900, fontStyle: 'italic', marginBottom: 24 }}>Edit Profil</h1>

      <div style={{ marginBottom: 28 }}>
        <div style={{ width: 90, height: 90, borderRadius: '50%', background: '#1C2128', overflow: 'hidden', marginBottom: 10, border: '2px solid #262b33' }}>
          {photoUrl && <img src={photoUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
        </div>
        <label style={{ display: 'inline-block', background: '#2B6996', color: '#fff', padding: '8px 16px', borderRadius: 6, fontSize: 12, cursor: 'pointer', fontWeight: 700 }}>
          {uploadingPhoto ? 'Mengupload...' : 'Ganti Foto'}
          <input type="file" accept="image/*" onChange={handlePhotoUpload} style={{ display: 'none' }} />
        </label>
      </div>

      <div style={{ marginBottom: 40 }}>
        <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 6 }}>Sosial Media</h2>
        <p style={{ fontSize: 12, color: '#8B92A0', marginBottom: 16 }}>
          Link ini bakal muncul di halaman profil publik kamu. Kosongkan kalau gak mau ditampilkan.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 420 }}>
          {SOCIAL_PLATFORMS.map((p) => (
            <div key={p.key}>
              <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'flex', alignItems: 'center', gap: 6 }}>
                <i className={p.icon} style={{ color: p.color, fontSize: 14 }}></i>
                {p.label}
              </label>
              <input
                placeholder={p.placeholder}
                value={socialLinks[p.key] || ''}
                onChange={(e) => setSocialLinks((prev) => ({ ...prev, [p.key]: e.target.value }))}
                style={inputStyle}
              />
            </div>
          ))}
          <button
            onClick={handleSaveSocialLinks}
            disabled={saving}
            style={{ background: '#D02127', color: '#fff', border: 'none', padding: 12, borderRadius: 6, fontWeight: 700, cursor: 'pointer', marginTop: 8 }}
          >
            {saving ? 'Menyimpan...' : 'Simpan Sosial Media'}
          </button>
        </div>
      </div>

      <form onSubmit={handleSaveProfile} style={{ marginBottom: 40 }}>
        <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 14 }}>Data Diri</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 400 }}>
          <div>
            <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>Nama</label>
            <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} style={inputStyle} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>Nomor HP</label>
            <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} style={inputStyle} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>Email</label>
            <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} style={inputStyle} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>Quote / Motto (tampil di card publik, maks 150 karakter)</label>
            <input
              value={form.quote}
              onChange={(e) => setForm({ ...form, quote: e.target.value })}
              maxLength={150}
              placeholder="Contoh: Solid selalu di jalan"
              style={inputStyle}
            />
            <p style={{ fontSize: 10, color: '#5a616e', marginTop: 4 }}>{form.quote.length}/150</p>
          </div>
          <h3 style={{ fontSize: 14, fontWeight: 800, marginTop: 10, color: '#D02127' }}>Kontak Darurat</h3>
          <p style={{ fontSize: 11, color: '#5a616e', marginTop: -8 }}>Hanya bisa dilihat Ketua/Wakil Ketua/Pengurus</p>
          <div>
            <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>Nama Kontak</label>
            <input value={form.urgent_contact_name} onChange={(e) => setForm({ ...form, urgent_contact_name: e.target.value })} style={inputStyle} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>Nomor HP Kontak</label>
            <input value={form.urgent_contact_phone} onChange={(e) => setForm({ ...form, urgent_contact_phone: e.target.value })} style={inputStyle} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>Hubungan</label>
            <input placeholder="Istri/Orang Tua/dll" value={form.urgent_contact_relation} onChange={(e) => setForm({ ...form, urgent_contact_relation: e.target.value })} style={inputStyle} />
          </div>
          <button type="submit" disabled={saving} style={{ background: '#D02127', color: '#fff', border: 'none', padding: 12, borderRadius: 6, fontWeight: 700, cursor: 'pointer', marginTop: 8 }}>
            {saving ? 'Menyimpan...' : 'Simpan Data Diri'}
          </button>
        </div>
      </form>

      <div style={{ marginBottom: 40 }}>
        <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 14 }}>Tipe Motor</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))', gap: 10, marginBottom: 20, maxWidth: 500 }}>
          {motorTypes.map((t) => (
            <div
              key={t.id}
              onClick={() => handleMotorTypeChange(t.id)}
              style={{
                cursor: 'pointer', textAlign: 'center', padding: 8, borderRadius: 8,
                background: motorType === t.id ? 'rgba(208,33,39,0.15)' : '#1C2128',
                border: motorType === t.id ? '2px solid #D02127' : '2px solid #262b33'
              }}
            >
              <img src={t.image_url} alt={t.name} style={{ width: '100%', height: 50, objectFit: 'contain' }} />
              <p style={{ fontSize: 10, marginTop: 4 }}>{t.name}</p>
            </div>
          ))}
        </div>

        {selectedMotor && (
          <HotspotEditor
            title="Atur Hotspot Motor"
            silhouetteUrl={selectedMotor.image_url}
            initialSpecs={motorSpecs}
            saveEndpoint="/member-auth/me/motor-specs"
            bodyKey="motor_specs"
            suggestedLabels={MOTOR_SUGGESTED_LABELS}
            enablePhotoUpload={true}
            photoUploadEndpoint="/upload/photo"
          />
        )}
      </div>

      <div>
        <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 14 }}>Set Gear</h2>
        <HotspotEditor
          title="Atur Hotspot Gear"
          silhouetteUrl={GEAR_PLACEHOLDER}
          initialSpecs={gearSpecs}
          saveEndpoint="/member-auth/me/gear-specs"
          bodyKey="gear_specs"
          suggestedLabels={GEAR_SUGGESTED_LABELS}
          enablePhotoUpload={true}
          photoUploadEndpoint="/upload/gear-photo"
        />
      </div>
    </Layout>
  );
}
